var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0213 26.3333C16.0213 23.6666 17.3333 22.3333 20 22.3333H26.6667C27.403 22.3333 28 21.7363 28 21V2.3333C28 1.59692 27.403 0.999963 26.6667 0.999963H20C18.8984 0.842789 17.7871 1.21334 17.0002 2.00018C16.2134 2.78703 15.8428 3.89836 16 4.99996C16.1572 3.89836 15.7866 2.78703 14.9998 2.00018C14.2129 1.21334 13.1016 0.842789 12 0.999963H5.33333C4.59695 0.999963 4 1.59692 4 2.3333V21C4 21.7363 4.59695 22.3333 5.33333 22.3333H12C14.6667 22.3333 16.0213 23.6666 16.0213 26.3333Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 3.66663H29.3333C30.0696 3.66663 30.6666 4.26358 30.6666 4.99996V23.6666C30.6666 24.403 30.0696 25 29.3333 25H22.6666C19.9999 25 17.9999 26.3333 17.9999 29H13.9999C13.9999 26.3333 11.9999 25 9.33325 25H2.66659C1.93021 25 1.33325 24.403 1.33325 23.6666V4.99996C1.33325 4.26358 1.93021 3.66663 2.66659 3.66663H3.99992",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5V25.6667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.c89c6affe9b648e47d9130b0317929d3.svg";
export { ForwardRef as ReactComponent };